var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coin-index"},[_c('div',{staticClass:"coin-index-header"},[_vm._v(" "+_vm._s(_vm.titleText)+" "),_c('span',{staticClass:"line"})]),_c('div',{staticClass:"coin-main"},[_c('org-account')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }